/* 무료보험 프로모션 추가부분 */
import React, { PropsWithChildren } from 'react'
import classNames from 'classnames/bind'

import Style from './InsurancePromotionLayout.module.scss'

const cx = classNames.bind(Style)

type Props = {
  isViewportHeight?: boolean
}

const InsurancePromotionLayout = ({ isViewportHeight, children }: PropsWithChildren<Props>) => {
  return (
    <div className={cx('article')} style={{ minHeight: isViewportHeight ? '100vh' : '' }}>
      {children}
    </div>
  )
}

export default InsurancePromotionLayout
